export var pinkBrandPlusColorsTokens = {
  'colors-plus-brand-primary': '#F2007D',
  'colors-plus-primary-dark': '#281242',
  'colors-plus-primary': '#421E6E',
  'colors-plus-primary-light': '#ECE9F0'
};
export var orangeBrandPlusColorsTokens = {
  'colors-plus-brand-primary': '#FF9700',
  'colors-plus-primary-dark': '#233038',
  'colors-plus-primary': '#3B505E',
  'colors-plus-primary-light': '#EBEEEF'
};
export var blueBrandPlusColorsTokens = {
  'colors-plus-brand-primary': '#3CB5DB',
  'colors-plus-primary-dark': '#003B72',
  'colors-plus-primary': '#0063BE',
  'colors-plus-primary-light': '#E6EFF9'
};
export var fallbackPlusColorsTokens = blueBrandPlusColorsTokens;
export var plusGradient = function plusGradient() {
  var gradientDirection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'to right';
  return function (_ref) {
    var theme = _ref.theme;
    return "linear-gradient(".concat(gradientDirection, ", ").concat(theme.commons.colors.plusPrimaryDark, ", ").concat(theme.commons.colors.plusPrimary, ")");
  };
};